import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import StyleContext from '../shared/StyleContext.js'
import App from '../shared/react-app.js'

// styles
import './styles/palette.scss'
import './styles/fonts.scss'
import './styles/main.scss'	
import './styles/media-report.scss'
import './styles/preview.table.scss'
import './styles/reports.body.scss'
import './styles/block.scss'
import './styles/module.scss'
import './styles/tags.selector.scss'
import './styles/list.selector.scss'
import './styles/filters.selector.scss'
import './styles/technology.selector.scss'
import './styles/action.table.scss'
import './styles/error.scss'
import './styles/preview.table.scss'
import './styles/selling.scss'
import './styles/commons.scss'
import './styles/calendly.scss'
import './styles/settings.scss'
import './styles/faq.scss'
import './styles/account.scss'
import './styles/subscription.scss'
import './styles/security.scss'
import './styles/table.scss'
import './styles/credits.scss'
import './styles/info-block.scss'
import './styles/wrap.scss'
import './styles/notice-window.scss'
import './styles/selector.scss'
import './styles/price.scss'
import './styles/custom.block.scss'

// Interface for style objects
interface Style {
	_insertCss(): () => void;
}

// // HMR
// if (module.hot) {
// 	module.hot.accept();
// }

const insertCss = (...styles: Style[]): (() => void) => {
	const removeCss = styles.map(style => style._insertCss())
	return () => removeCss.forEach(dispose => dispose())
};

const rootElement = document.getElementById('root');

if (!rootElement) {
	throw new Error('Root element not found');
}

if (undefined != window.__WTS_SSR_DATA__) {
	// Hydrate server-rendered content
	ReactDOM.hydrateRoot(
		rootElement,
		<React.StrictMode>
			<StyleContext.Provider value={{ insertCss }}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</StyleContext.Provider>
		</React.StrictMode>
	);

	delete window.__WTS_SSR_DATA__;
} else {
	// Client-only rendering
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		<React.StrictMode>
			<StyleContext.Provider value={{ insertCss }}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</StyleContext.Provider>
		</React.StrictMode>
	);
}